import { PdFormFieldset } from "./pd-form-fieldset/PdFormFieldset.js";
//#region src/pd-form-fieldset/pd-form-fieldset.ts
var tag = "pd-form-fieldset";
if (!customElements.get(tag)) customElements.define(tag, PdFormFieldset);
//#endregion
export { PdFormFieldset };
